export default __webpack_public_path__ + "static/media/hint.a8775883.svg";